import { configureStore } from '@reduxjs/toolkit';
import { userReducer } from './Reducers/User';
import { jobsReducer } from './Reducers/Jobs';
import { postsReducer } from './Reducers/posts';
import { resourcesReducer } from './Reducers/Resources';
import { userprofileReducer } from './Reducers/UserProfile';

const store = configureStore({

    reducer:{
        user : userReducer,
        jobs : jobsReducer,
        posts : postsReducer,
        resources : resourcesReducer,
        userprofile : userprofileReducer
    }

});

export default store;